export enum Types {
	FETCH_POKEMON_REQUEST = "FETCH_POKEMON_REQUEST",
	FETCH_POKEMON_SUCCESS = "FETCH_POKEMON_SUCCESS",
	FETCH_POKEMON_FAILED = "FETCH_POKEMON_FAILED",
}
